import { DateTime } from 'luxon'

export const TRIAL_LENGTH_IN_DAYS = 14
export const TRIAL_NOTICE_THRESHOLD = 7
export const TRIAL_WARNING_THRESHOLD = 3

/**
 * Returns the number of days remaining in a user's free trial
 * @param createdAt
 * @returns {number}
 */
export function calculateTrialDaysRemaining(createdAt) {
  const createDate = DateTime.fromISO(createdAt)
  const today = DateTime.utc()
  return Math.round(TRIAL_LENGTH_IN_DAYS - today.diff(createDate, 'days').days)
}
